import * as fs from 'fs';

export namespace testutil {

	export function strip_comments(s: string): string
		{
			let aIn = s.split('\n');
			let aOut = [];
			for (let i = 0; i < aIn.length; i++)
				if (aIn[i].substr(0, 2) != "//")
					aOut.push(aIn[i]);
			return aOut.join(" ");
		}

	export function find_data_path(name: string): string
		{
			let s: string = name;

			try
			{
				fs.accessSync(s);
				return s;
			}
			catch (err)
			{
				s = "data/" + name;
				try
				{
					fs.accessSync(s);
					return s;
				}
				catch (err)
				{
					s = "../data/" + name;
					fs.accessSync(s);
					return s;
				}
			}
		}
};
